<template>
  <div class="modal fade" id="metaEdit" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered  w-[800px] ">
          <Form class="w-full" @submit="onSubmit" :validation-schema="schema">

              <div class="modal-content">
                  <div class="modal-header">
                      <h1 class="modal-title fs-5">Update Site Information</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body ">
                      <div class="overflow-hidden">
                          <div class="float-left p-2 h-20 w-full">
                              Title:
                              <v-text-field v-model="title" variant="outlined" density="compact"
                                  rounded="0"></v-text-field>
                          </div>
                          <div class="float-left p-2 w-full ">
                              Description:
                              <v-textarea v-model="description" variant="outlined" density="compact"
                                  rounded="0"></v-textarea>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                      <button type="submit" :disabled="buttonDisableFlag" class="btn btn-primary">Update</button>
                  </div>
              </div>
          </Form>

      </div>
  </div>
</template>



<script setup>
import { ref, defineEmits, defineProps, watchEffect } from "vue";
import { useAdminUserStore } from "@/stores";
import { Form } from 'vee-validate';
const props = defineProps({
    title: {
        type: String,
        required: true
    },
    description: {
        type: String,
        required: true
    }
})
const title = ref("");
const description = ref("");


const buttonDisableFlag = ref(false)
const emit = defineEmits(['updated'])

watchEffect(() => {
  title.value = props?.title;
  description.value = props.description;
})

const adminUserStore = useAdminUserStore();

const onSubmit = () => {
  const createRequest = {
    title: title.value,
    description: description.value,
  };
  buttonDisableFlag.value = true
  adminUserStore.saveSiteInfo(createRequest).then(() => {
    buttonDisableFlag.value = false
    emit('updated')
  });
};

</script>
<style>
.v-textarea .v-field--no-label textarea, .v-textarea .v-field--active textarea {
  font-size: 12px;
}
</style>